import { rootStateBranchSelector } from '../../utils/rootStateBranchSelector';

export const featureToggleSelector = rootStateBranchSelector('featureToggle');
